import * as React from 'react'

import { Box, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Files } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import CopyPeriodWizard from 'modules/shift_management/components/ShiftManagement/CopyPeriodWizard'

interface Props {
  disabled?: boolean
}
const CopyPeriodButton = ({ disabled }: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false)
  const [isTooltipOpen, toggleTooltip] = useToggle(false)
  return (
    <>
      {isModalOpen && <CopyPeriodWizard onClose={() => setIsModalOpen(false)} />}
      <Box onMouseEnter={toggleTooltip(!disabled)} onMouseLeave={toggleTooltip(false)}>
        <Tooltip.Alt
          open={isTooltipOpen}
          attachment="top center"
          label={i18n.t('shift_management.actions.copy_schedule_period')}
        >
          <F0Button
            hideLabel
            icon={Files}
            onClick={() => setIsModalOpen(true)}
            size="md"
            variant="outline"
            disabled={disabled}
          />
        </Tooltip.Alt>
      </Box>
    </>
  )
}

export default CopyPeriodButton
